exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".confirm-refill-addon-modal {\n  padding: 1.5em 5%;\n}\n.confirm-refill-addon-modal .added-text {\n  padding: 1.5em 0;\n}\n.confirm-refill-addon-modal .no-thanks {\n  padding: 1em 0;\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

// exports
